import React from 'react';

const CableMarking = React.memo(({ type, position, content, isFlipped, fromEnd = false, getMarkingPosition, y1 }) => {
  if (!content) return null;

  const x = getMarkingPosition(position, fromEnd);
  const textWidth = Math.max(content.length * 7, 30);

  return (
    <g className="cable-marking">
      <rect
        x={x - textWidth / 2} y={y1 - 8}
        width={textWidth} height={16}
        rx={3}
        fill="white"
        stroke="#D1D5DB"
        strokeWidth={1}
        filter="drop-shadow(0 1px 3px rgba(0, 0, 0, 0.2))"
      />

      <text
        x={x} y={y1 + 4}
        className="text-xs font-bold fill-gray-800"
        textAnchor="middle"
        transform={isFlipped ? `rotate(180, ${x}, ${y1})` : ''}
      >
        {content}
      </text>
    </g>
  );
});

export default CableMarking;
